import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import * as DetailList from "~/components/DetailList";
import { Box, Padding, Content } from "~/components/Elements";
import { getMetabaseIFrameURL } from "~/endpoints/utils";

const MetaBaseIframe = styled.iframe`
  overflow: hidden;
  border: 0px;
  height: 400px;
  @media (max-width: 812px) {
    height: 1200px;
  }
`;

const Container = styled.div`
  width: 100%;
`;

export default function VASPAnalyticsDashboard({ vaspId }: { url?: string; vaspId: string }) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [metaBaseIFrameURL, setMetabaseIFrameURL] = useState<string>();

  useEffect(() => {
    getIFrameURL(vaspId);
  }, [vaspId]);

  async function getIFrameURL(did: string) {
    const metaBaseResponse = await getMetabaseIFrameURL({
      payload: {
        did,
      },
    });
    setMetabaseIFrameURL(metaBaseResponse.iframeURL);
  }

  return (
    <Box as={Container}>
      <Padding sized="medium">
        <DetailList.Header>
          <DetailList.Item mobile={12}>
            <DetailList.Title as="h2">VASP Profile Data</DetailList.Title>
          </DetailList.Item>
        </DetailList.Header>
        <Content>
          <MetaBaseIframe ref={iframeRef} src={`${metaBaseIFrameURL}#bordered=true&titled=false`} width="100%" />
        </Content>
      </Padding>
    </Box>
  );
}
